__turbopack_context__.v({
  "className": "geist_mono_4e26fe1b-module__-_Fr9q__className",
  "variable": "geist_mono_4e26fe1b-module__-_Fr9q__variable",
});
